module.exports = __webpack_public_path__ + "static/scale-model-of-pettigrew-home-&-museum-in-sioux-falls-south-dakota-11c108a974520ce5a990a7d2951c8ca0.png";